import {expectEitherAndCrash, HttpClient} from '@raison/network-facade';
import {AccountId, CardId} from '@raison/types';
import {Order} from '~/shared/api/legacy_services/wallets';

export function checkStripeOrder(http: HttpClient, accountId: AccountId, cardId: CardId, externalId: string | number) {
    return http(`v1/accounts/${accountId}/receive/cards/${cardId}/${externalId}`).then(
        ...expectEitherAndCrash({
            200: Order,
            204: null,
        })
    );
}
